import { useEffect, useState } from 'react';
import { useSetting } from '../../../util/useSetting';
import { useParams } from 'react-router-dom';

export default function RenderAQuestion({ savedAnswers, question, onSave, enableAnswer, label, index }) {
    const { id } = useParams();
    const { fontSize } = useSetting();
    const [isSelectingOption, setIsSelectingOption] = useState(false);
    const [selectedArea, setSelectedArea] = useState(null);
    const [studentAnswer, setStudentAnswer] = useState(null);

    const [interactionAnswer1, setInteractionAnswer1] = useState(null);
    const [interactionAnswer2, setInteractionAnswer2] = useState(null);
    const [interactionAnswer3, setInteractionAnswer3] = useState(null);
    const [interactionAnswer4, setInteractionAnswer4] = useState(null);
    const [interactionAnswer5, setInteractionAnswer5] = useState(null);
    const [interactionAnswer6, setInteractionAnswer6] = useState(null);

    useEffect(() => {
        if (enableAnswer) {
            const answer = savedAnswers.filter(item => item.questionId === `${label}_${question?.id}`)[0]?.answer || null;

            if (question.type === '互動題' || question.type === '儒家知識卡' || question.type === '互動題2') {
                setInteractionAnswer1(answer?.[0] || null);
                setInteractionAnswer2(answer?.[1] || null);
                setInteractionAnswer3(answer?.[2] || null);
                setInteractionAnswer4(answer?.[3] || null);
                setInteractionAnswer5(answer?.[4] || null);
                setInteractionAnswer6(answer?.[5] || null);
            } else {
                setSelectedArea(answer);
                setStudentAnswer(answer);
            }
        }
    }, [savedAnswers, question, enableAnswer, label])

    return (
        <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]' style={{ background: "linear-gradient(to top, #fff, #F0FBFF)" }}>
            <div>{question?.question}</div>
            {
                question.type === '座標題1' ?
                    <div className='p-[8px] rounded-[8px] flex flex-row gap-[8px]'>
                        <div className='flex flex-1 flex-col bg-white items-center gap-[4px]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                            <div>豁達／平靜</div>
                            <div className='flex flex-row w-full items-center gap-[4px]'>
                                <div>逃避／出世  </div>
                                <div className='flex flex-col flex-1 gap-[4px] relative'>
                                    <div className='flex flex-row w-full gap-[4px]'>
                                        <button className='flex-1 bg-[#82828240]' style={{ aspectRatio: '17 / 12', height: undefined }} onClick={() => {
                                            if (isSelectingOption) {
                                                setSelectedArea('1');
                                                setIsSelectingOption(false);
                                            }
                                        }}>
                                            {isSelectingOption && <div className='glowingAnimation w-full h-full' />}
                                            {selectedArea === '1' && !isSelectingOption &&
                                                <button className='px-[20px] py-[8px] rounded-[8px]' style={{ backgroundColor: '#EE8D59', color: 'white' }}>歐陽修</button>
                                            }
                                        </button>
                                        <button className='flex-1 bg-[#82828240]' style={{ aspectRatio: '17 / 12', height: undefined }} onClick={() => {
                                            if (isSelectingOption) {
                                                setSelectedArea('2');
                                                setIsSelectingOption(false);
                                            }
                                        }}>
                                            {isSelectingOption && <div className='glowingAnimation w-full h-full' />}
                                            {selectedArea === '2' && !isSelectingOption &&
                                                <button className='px-[20px] py-[8px] rounded-[8px]' style={{ backgroundColor: '#EE8D59', color: 'white' }}>歐陽修</button>
                                            }
                                        </button>
                                    </div>
                                    <div className='flex flex-row w-full gap-[4px]'>
                                        <button className='flex-1 bg-[#82828240]' style={{ aspectRatio: '17 / 12', height: undefined }} onClick={() => {
                                            if (isSelectingOption) {
                                                setSelectedArea('3');
                                                setIsSelectingOption(false);
                                            }
                                        }}>
                                            {isSelectingOption && <div className='glowingAnimation w-full h-full' />}
                                            {selectedArea === '3' && !isSelectingOption &&
                                                <button className='px-[20px] py-[8px] rounded-[8px]' style={{ backgroundColor: '#EE8D59', color: 'white' }}>歐陽修</button>
                                            }
                                        </button>
                                        <button className='flex-1 bg-[#82828240]' style={{ aspectRatio: '17 / 12', height: undefined }} onClick={() => {
                                            if (isSelectingOption) {
                                                setSelectedArea('4');
                                                setIsSelectingOption(false);
                                            }
                                        }}>
                                            {isSelectingOption && <div className='glowingAnimation w-full h-full' />}
                                            {selectedArea === '4' && !isSelectingOption &&
                                                <button className='px-[20px] py-[8px] rounded-[8px]' style={{ backgroundColor: '#EE8D59', color: 'white' }}>歐陽修</button>
                                            }
                                        </button>
                                    </div>
                                    {isSelectingOption && <div className='absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 text-[#EE8D59] bg-[white]'>點擊選擇區域</div>}
                                </div>
                                <div>面對／入世</div>
                            </div>
                            <div>悲憤／孤傲</div>
                        </div>
                        <div className='px-[8px]'>
                            <button onClick={() => { setIsSelectingOption(!isSelectingOption) }} className='px-[20px] py-[8px] rounded-[8px]' style={{ backgroundColor: isSelectingOption ? '#EE8D59' : '#82828240', color: isSelectingOption ? 'white' : 'black' }}>歐陽修</button>
                        </div>
                    </div>
                    :
                    question.type === '選擇題' ?
                        <div className='p-[8px] rounded-[8px] flex flex-col gap-[8px]'>
                            {question.options?.map((option, idx) => (
                                <div key={idx} className='w-full rounded-full bg-[white]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                    <div className='px-[16px] py-[8px] min-w-[140px] rounded-[8px] checkbox-main gap-[6px] flex flex-row items-center noto-san-hk'>
                                        <button style={{ width: 25, height: 25, borderRadius: '99px', border: '2px solid #005B8C', }} onClick={() => setStudentAnswer(option.option)} >
                                            {studentAnswer === option.option && <div className='w-full h-full bg-[#005B8C] rounded-full' />}
                                        </button>
                                        <span>{option.option}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        :
                        question.type === '互動題' ?
                            <div className='p-[8px] rounded-[8px] flex flex-col gap-[8px] w-full bg-[white] font-[400]'>
                                <div className='w-full flex flex-row justify-between items-center gap-[8px]'>
                                    <img src='/secondary/p1.png' alt='interaction' className='w-[77px] h-[77px]' />
                                    <div className='flex flex-1 flex-col gap-[2px]'>
                                        <div className='text-[#0044FF]'>歐陽修</div>
                                        <div>1 小時前【發佈動態】</div>
                                    </div>
                                    <button><img src='/secondary/more.png' alt='interaction' className='w-[28px]' /></button>
                                </div>
                                <div className='font-[400]'>剛被貶到滁州，心情本來有點悶，但看到這裡的風景，我突然領悟了……</div>
                                <div className='font-[400]'>引用我的名言：</div>
                                <textarea className='rounded-[8px] w-full p-[8px] border-[1px] border-[#ccc]' placeholder='請學生回答' value={interactionAnswer1 || ''} onChange={(e) => setInteractionAnswer1(e.target.value)} />
                                <div className='font-[400]'>我的真實心聲：</div>
                                <textarea className='rounded-[8px] w-full p-[8px] border-[1px] border-[#ccc]' placeholder='請學生回答' value={interactionAnswer2 || ''} onChange={(e) => setInteractionAnswer2(e.target.value)} />
                                <img className='w-full object-cover' src='/secondary/comments.png' alt='interaction' />

                                <div className='font-[400]' style={{ fontSize: fontSize - 4 }}>回應</div>
                                <div className='w-full flex flex-row justify-between items-center gap-[8px] font-[400]'>
                                    <img src='/secondary/p1.png' alt='interaction' className='w-[77px] h-[77px]' />
                                    <div className='flex flex-col gap-[2px] mr-[16px]'>
                                        <div className='text-[black]'>蘇軾</div>
                                    </div>
                                    <div className='flex-1 text-left'>
                                        前輩說得好！但如果要徹底不為貶謫感到痛苦，我的秘訣是換個角度看宇宙……
                                    </div>
                                </div>
                                <div className='font-[400]'>引用我的名言：</div>
                                <textarea className='rounded-[8px] w-full p-[8px] border-[1px] border-[#ccc]' placeholder='請學生回答' value={interactionAnswer3 || ''} onChange={(e) => setInteractionAnswer3(e.target.value)} />
                                <div className='font-[400]'>我的真實心聲：</div>
                                <textarea className='rounded-[8px] w-full p-[8px] border-[1px] border-[#ccc]' placeholder='請學生回答' value={interactionAnswer4 || ''} onChange={(e) => setInteractionAnswer4(e.target.value)} />
                                <div className='h-[1px] bg-[#ccc] w-full' />
                                <div className='w-full flex flex-row justify-between items-center gap-[8px] font-[400]'>
                                    <img src='/secondary/p1.png' alt='interaction' className='w-[77px] h-[77px]' />
                                    <div className='flex flex-col gap-[2px] mr-[16px]'>
                                        <div className='text-[black]'>范仲淹</div>
                                    </div>
                                    <div className='flex-1 text-left'>
                                        兩位的境界都很高，但身為讀書人，我們還有更重要的責任要扛！
                                    </div>
                                </div>
                                <div className='font-[400]'>引用我的名言：</div>
                                <textarea className='rounded-[8px] w-full p-[8px] border-[1px] border-[#ccc]' placeholder='請學生回答' value={interactionAnswer5 || ''} onChange={(e) => setInteractionAnswer5(e.target.value)} />
                                <div className='font-[400]'>我的真實心聲：</div>
                                <textarea className='rounded-[8px] w-full p-[8px] border-[1px] border-[#ccc]' placeholder='請學生回答' value={interactionAnswer6 || ''} onChange={(e) => setInteractionAnswer6(e.target.value)} />
                            </div>
                            : question.type === '儒家知識卡' ?
                                <div className='rounded-[8px] flex flex-col gap-[8px] w-full'>
                                    閱讀平台準備製作一組「30秒讀懂儒家」知識卡。以下內容都根據兩篇拓展文章整理。<br /><br />
                                    判斷標準 <br />
                                    A 可以直接上線<br />內容準確，表述清楚。<br /><br />
                                    B 基本正確，需要小幅修改<br />核心意思成立，但有表述不夠準確、過度概括或需要補充限定的地方。 <br /><br />
                                    C 容易造成明顯誤解，需要重新改寫<br />內容存在重要錯誤、概念混淆，或對文章觀點作出了失真的概括。<br /><br />
                                    如果選擇B或C，請直接寫出你的修改版本。

                                    <div className='text-white p-[16px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }}>
                                        知識卡一<br /><br />儒家的核心是「仁」。仁使人心中有他人；義、禮、智、信則從不同方面規範人的判斷、行為與人際關係，共同形成儒家的價值體系。
                                    </div>
                                    我的判斷：
                                    <div className='flex flex-row bg-white rounded-full gap-[16px] p-[4px]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                        <input type="radio" onClick={() => {
                                            setInteractionAnswer1('A')
                                        }} checked={interactionAnswer1 === 'A'} />
                                        A　可以直接上線
                                    </div>
                                    <div className='flex flex-row bg-white rounded-full gap-[16px] p-[4px]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                        <input type="radio" onClick={() => {
                                            setInteractionAnswer1('B')
                                        }} checked={interactionAnswer1 === 'B'} />
                                        B　基本正確，需要小幅修改
                                    </div>
                                    <div className='flex flex-row bg-white rounded-full gap-[16px] p-[4px]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                        <input type="radio" onClick={() => {
                                            setInteractionAnswer1('C')
                                        }} checked={interactionAnswer1 === 'C'} />
                                        C 容易造成明顯誤解，需要重新改寫
                                    </div>
                                    {interactionAnswer1 === 'B' || interactionAnswer1 === 'C' ? (
                                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' placeholder="請直接寫出你的修改版本。" value={interactionAnswer2 || ''} onChange={(e) => setInteractionAnswer2(e.target.value)} />
                                    ) : null}

                                    <div className='text-white p-[16px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }}>
                                        知識卡二<br /><br />「君子」原本主要是一種身份稱謂，經過孔子以後逐漸成為理想人格的名稱。後世文人又用蓮、竹、梅等形象表現君子的品格。
                                    </div>
                                    我的判斷：
                                    <div className='flex flex-row bg-white rounded-full gap-[16px] p-[4px]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                        <input type="radio" onClick={() => { setInteractionAnswer3('A') }} checked={interactionAnswer3 === 'A'} />
                                        A　可以直接上線
                                    </div>
                                    <div className='flex flex-row bg-white rounded-full gap-[16px] p-[4px]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                        <input type="radio" onClick={() => {
                                            setInteractionAnswer3('B')
                                        }} checked={interactionAnswer3 === 'B'} />
                                        B　基本正確，需要小幅修改
                                    </div>
                                    <div className='flex flex-row bg-white rounded-full gap-[16px] p-[4px]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                        <input type="radio" onClick={() => {
                                            setInteractionAnswer3('C')
                                        }} checked={interactionAnswer3 === 'C'} />
                                        C 容易造成明顯誤解，需要重新改寫
                                    </div>
                                    {interactionAnswer3 === 'B' || interactionAnswer3 === 'C' ? (
                                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' placeholder="請直接寫出你的修改版本。" value={interactionAnswer4 || ''} onChange={(e) => setInteractionAnswer4(e.target.value)} />
                                    ) : null}

                                    <div className='text-white p-[16px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }}>
                                        知識卡三<br /><br />孟子主張性善，荀子主張性惡，因此兩人的儒家思想方向完全相反：孟子相信人依靠天性便能成為有德之人，荀子則認為只能依靠外在規則約束人。
                                    </div>
                                    我的判斷：
                                    <div className='flex flex-row bg-white rounded-full gap-[16px] p-[4px]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                        <input type="radio" onClick={() => { setInteractionAnswer5('A') }} checked={interactionAnswer5 === 'A'} />
                                        A　可以直接上線
                                    </div>
                                    <div className='flex flex-row bg-white rounded-full gap-[16px] p-[4px]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                        <input type="radio" onClick={() => {
                                            setInteractionAnswer5('B')
                                        }} checked={interactionAnswer5 === 'B'} />
                                        B　基本正確，需要小幅修改
                                    </div>
                                    <div className='flex flex-row bg-white rounded-full gap-[16px] p-[4px]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                        <input type="radio" onClick={() => {
                                            setInteractionAnswer5('C')
                                        }} checked={interactionAnswer5 === 'C'} />
                                        C 容易造成明顯誤解，需要重新改寫
                                    </div>
                                    {interactionAnswer5 === 'B' || interactionAnswer5 === 'C' ? (
                                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' placeholder="請直接寫出你的修改版本。" value={interactionAnswer6 || ''} onChange={(e) => setInteractionAnswer6(e.target.value)} />
                                    ) : null}
                                </div> :
                                question.type === '互動題2' ?
                                    <div className='rounded-[8px] flex flex-col gap-[8px] w-full'>
                                        例如：
                                        <br /><br />
                                        一位好朋友在重要測驗中作弊，事後請你替他保守秘密，並說：「如果你把我當朋友，就不要告訴老師。」
                                        <br /><br />
                                        在這個處境中，「關心朋友」、「明辨是非」、「遵守規則」、「誠信待人」可能同時影響我們的判斷。儒家的不同概念，也會提醒我們看到問題的不同方面。
                                        <br /><br />
                                        <div className='text-[#55A8E0]'>第一步：回想一個自己的處境</div>
                                        請回想一次你曾經需要作出選擇的真實經歷。可以來自朋友相處、家庭生活、學校活動、團隊合作、網絡交流、利益分配等日常情境。
                                        <br /><br />
                                        你不需要寫涉及個人私隱的事情，只需交代足以理解這次選擇的背景。
                                        <br /><br />
                                        <div className='text-[#178E95]'>當時發生了甚麼？我需要在甚麼之間作出選擇？</div>
                                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' value={interactionAnswer1 || ''} onChange={(e) => setInteractionAnswer1(e.target.value)} />
                                        <div className='text-[#178E95]'>我最後怎樣選擇？</div>
                                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' value={interactionAnswer2 || ''} onChange={(e) => setInteractionAnswer2(e.target.value)} />
                                        <br/>
                                        <div className='text-[#55A8E0]'>第二步：用儒家的價值觀重新看看這件事</div>
                                        從以下概念中，選擇與你的處境有關的概念。
                                        <div className='flex flex-wrap gap-[8px] w-full'>
                                            {['仁','義','禮','智','信','孝悌','忠恕','君子']?.map((concept) => (
                                                <button key={concept} onClick={() => { 
                                                    if(isSelectingOption===concept)
                                                        setIsSelectingOption(null)
                                                    else {
                                                        setIsSelectingOption(concept)
                                                    }
                                                }} className='px-[20px] py-[8px] rounded-[8px]' style={{ backgroundColor: isSelectingOption===concept ? '#FDA73F' : '#82828240', color: isSelectingOption===concept ? 'white' : 'black' }}>
                                                    {concept}
                                                </button>
                                            ))}
                                        </div>
                                         <div className='w-full flex flex-row gap-[4px]'>
                                            <div className='flex flex-col flex-1'>
                                                與我的處境有關的概念
                                               
                                            </div>
                                            <div className='flex flex-col flex-1'>
                                                我如何理解這個概念
                                               
                                            </div>
                                            <div className='flex flex-col flex-1'>
                                                放回當時的處境，它會怎樣影響我的判斷？
                                               
                                            </div>
                                        </div>
                                        <div className='w-full flex flex-row gap-[4px]'>
                                            <div className='flex flex-col flex-1'>
                                                <button onClick={() => { 
                                                    if(!isSelectingOption) return;
                                                    let arr= [...interactionAnswer3||[]]
                                                    if(arr.includes(isSelectingOption)){
                                                        arr = arr.filter(item => item !== isSelectingOption)
                                                    }else{
                                                        arr.push(isSelectingOption)
                                                    }
                                                    setInteractionAnswer3(arr)
                                                    setIsSelectingOption(null) 
                                                }} className='w-full relative flex flex-row flex-wrap items-center justify-center gap-[4px]' style={{ height:undefined,aspectRatio:'1',backgroundColor: '#82828240'}}>
                                                     {isSelectingOption && <div className='glowingAnimation w-full h-full absolute top-0' />}
                                                     {(interactionAnswer3||[])?.map(concept=>
                                                        <div key={concept}>
                                                            <button onClick={() => {
                                                                //remove from interactionAnswer3
                                                                if(isSelectingOption) return;
                                                                let arr= [...interactionAnswer3||[]]
                                                                if(arr.includes(concept)){
                                                                    arr = arr.filter(item => item !== concept)
                                                                }
                                                                setInteractionAnswer3(arr)
                                                            }} className='px-[20px] py-[8px] rounded-[8px]' style={{ backgroundColor: '#FDA73F' , color:  'white' }}>
                                                                {concept}
                                                            </button>
                                                        </div>
                                                     )}
                                                </button>
                                            </div>
                                            <div className='flex flex-col flex-1'>
                                                <button className='w-full relative' style={{ height:undefined,aspectRatio:'1',backgroundColor: '#82828240'}}>
                                                    {isSelectingOption && <div className='glowingAnimation w-full h-full' />}
                                                </button>
                                            </div>
                                            <div className='flex flex-col flex-1'>
                                                <button className='w-full relative' style={{ height:undefined,aspectRatio:'1',backgroundColor: '#82828240'}}>
                                                    {isSelectingOption && <div className='glowingAnimation w-full h-full' />}
                                                </button>
                                            </div>
                                        </div>
                                        <br/>
                                        <div className='text-[#55A8E0]'>第三步：重新作一次選擇</div>
                                        經過以上分析，如果今天再次面對同樣的處境：<br/><br/>我會怎麼做：<br/><br/>
                                        <div className='text-[#55A8E0]'>想一想</div>
                                        從自己的這次經歷來看，儒家的核心概念可以怎樣幫助我們處理生活中的人際關係與價值判斷？
                                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' value={interactionAnswer6 || ''} onChange={(e) => setInteractionAnswer6(e.target.value)} />
                                    </div>

                                    : <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' value={studentAnswer || ''} onChange={(e) => setStudentAnswer(e.target.value)} />
            }
            <div className='flex flex-row justify-end'>
                <button className='text-white px-[36px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }}
                    onClick={() => {
                        if (onSave) {
                            let ans = ''
                            if (question.type === '座標題1') {
                                ans = selectedArea
                            } else if (question.type === '選擇題') {
                                ans = studentAnswer
                            } else if (question.type === '短答題') {
                                ans = studentAnswer
                            } else if (question.type === '互動題' || question.type === '儒家知識卡' || question.type === '互動題2') {
                                ans = [interactionAnswer1, interactionAnswer2, interactionAnswer3, interactionAnswer4, interactionAnswer5, interactionAnswer6]
                            }
                            onSave(ans)
                        }
                    }}
                >
                    儲存
                </button>
            </div>
        </div>
    )
}